<div fxLayout="row wrap">
    
    <div fxFlex="50" fxFlex.xl="16.6" fxFlex.lg="16.6" fxFlex.md="33.3" fxFlex.sm="33.3" class="p-2">        
        <mat-card class="gradient-red tile p-2"> 
            <mat-icon>monetization_on</mat-icon> 
            <h2>{{sum}} {{currency}}</h2>         
            <p>Total Paiement</p>            
        </mat-card>
    </div>
    <div fxFlex="50" fxFlex.xl="20" fxFlex.lg="16.6" fxFlex.md="33.3" fxFlex.sm="33.3" class="p-2">        
        <mat-card class="gradient-green tile p-2"> 
            <mat-icon>monetization_on</mat-icon> 
            <h2>{{gain}} {{currency}}</h2>         
            <p>Total des Bénefices pour SILOKA</p>            
        </mat-card>
    </div>
</div>

<div fxLayout="row" class="p-2" class="search">
    <button  mat-icon-button  color="primary" matTooltip="Affichage en Grille" (click)="changeViewType('grid')">
        <span><mat-icon>grid_view</mat-icon></span>
    </button>
    <button  mat-icon-button  color="primary" matTooltip="Affichage en Liste" (click)="changeViewType('list')">
        <span><mat-icon>format_list_bulleted</mat-icon></span>
    </button>

    <mat-button-toggle-group #controls="matButtonToggleGroup" appearance="legacy">            

        <mat-button-toggle value="search">
            <mat-icon>search</mat-icon>
        </mat-button-toggle>           
    </mat-button-toggle-group>            
    <form class="user-search" [class.show]="controls.value == 'search'">
        <mat-form-field class="user-search-input">
            <input matInput placeholder="Recherche un Paiement..." (keyup)="applyFilter($event)" name="search">
        </mat-form-field>
    </form>
</div>
<mat-card class="m-2 p-0">
   
    <div class="table-wrapper" *ngIf="viewType==='list'"> 
        <table mat-table [dataSource]="dataSource" matSort class="w-100">
        
            <!-- Payment Number Column -->
            <ng-container matColumnDef="paymentNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> N° de Transaction </th>
                <td mat-cell *matCellDef="let payment">#{{payment.paiement_number}} </td>
            </ng-container> 
            
            <!-- Amount Column -->
            <ng-container matColumnDef="amount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Montant </th>
                <td mat-cell *matCellDef="let payment">{{payment.paiement_montant}} {{currency}}</td>
            </ng-container>
    
            <!-- Payment Method Column -->
            <ng-container matColumnDef="paymentMethod">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Moyen de paiement </th>
                <td mat-cell *matCellDef="let payment">{{payment.paiement_means_paie}}</td>
            </ng-container>  
            
            <!-- Renting Column -->
            <ng-container matColumnDef="renting">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Location </th>
                <td mat-cell *matCellDef="let payment">
                    <span>Départ : 
                        <span class="period-location">{{payment.date_departure}}</span>   
                        {{payment.hour_departure}}<br>
                    </span> 
                       
                    <span>Retour : 
                        <span class="period-location">{{payment.date_return}}</span>   
                        {{payment.hour_return}}<br>
                    </span> 
                </td>
            </ng-container>   

            <!-- Car Column -->
            <ng-container matColumnDef="car">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Véhicule </th>
                <td mat-cell *matCellDef="let payment">{{payment.vehicle}}</td>
            </ng-container> 
    
            <!-- Logder Column -->
            <ng-container matColumnDef="Logder">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Locataire </th>
                <td mat-cell *matCellDef="let payment">{{payment.lodger}}</td>
            </ng-container>  

            <!-- Owner Column -->
            <ng-container matColumnDef="owner">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Propriètaire </th>
                <td mat-cell *matCellDef="let payment">{{payment.owner}}</td>
            </ng-container>  

             <!-- Date Column -->
             <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                <td mat-cell *matCellDef="let payment">{{ payment.date | date:"dd MMMM, yyyy 'à' HH:mm" }} </td>
            </ng-container> 
        
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let payment; columns: displayedColumns;"></tr>
        </table> 
        <p *ngIf="dataSource && dataSource.data.length === 0" class="py-5 mb-0 text-center">No data available</p> 
    </div>
    <div fxLayout="row wrap" fxLayoutAlign="center" class="w-100 p-2" *ngIf="viewType==='grid'">
        <mat-card class="menu-item" [fxLayout]="(viewType == 'grid') ? 'column' : 'row'"
            [ngClass]="[viewType + '-item', 'column-'+column]" fxFlex.gt-sm="30" fxFlex.sm="30"  *ngFor="let item of payments | paginate: { itemsPerPage: 10, currentPage: p }">
           
            <div fxFlex="100" class="p-3">
                <div fxLayout="column" fxLayoutAlign="start stretch" class="h-100">
                    <mat-card-content class="mb-0">
                        <mat-icon class="icon-title">payments</mat-icon>
                        <h1 class="title">
                            {{item.paiement_montant | currency : currency : 'symbol' : '1.2-2'}}
                        </h1>
                        <span class="subtitle">Trans N°_{{item.paiement_number}}</span>
                        <div> 
                            <div class="features">
                                propriétaire : {{item.owner}} <br>
                                Locataire : {{item.lodger}} <br>
                                <h3> Réservé  Du {{item.date_departure | date:"dd MMMM, yyyy 'a' HH:mm" }} Au {{item.date_return | date:"dd MMMM, yyyy 'a' HH:mm" }} </h3>
                            </div>
                        </div>
                    </mat-card-content>
                    <mat-card-actions class="m-0 p-0">
                        <div class="divider mt-1">
                            <span class="text-muted text-center">
                                {{item.date | date:"dd MMMM, yyyy 'a' HH:mm" }} <br>Payée par {{item.paiement_means_paie}}
                            </span>
                        </div>
                    </mat-card-actions>
                </div>
            </div>
        </mat-card>
        <p *ngIf="payments && payments.length === 0" class="py-5 mb-0 text-center">No data available</p> 

    </div>

    <div fxLayout="row wrap" fxLayoutAlign="space-between" class="w-100 p-2">
        <div fxFlex="100" fxFlex.gt-sm="20" fxFlex.sm="20">
            <button  mat-icon-button  color="primary" matTooltip="Rafraichir" (click)="refresh()">
                <span><mat-icon>refresh</mat-icon> Mise à jour</span>
            </button>
        </div>
        
        <div fxFlex="100" fxFlex.gt-sm="80" fxFlex.sm="80" *ngIf="viewType==='grid'">
            <pagination-controls (pageChange)="p = $event" style="text-align: end;"></pagination-controls>
        </div>
        <mat-paginator [pageSizeOptions]="[5, 10, 25, 50]" class="{{viewType==='list' ? 'block' : 'hidden'}}"></mat-paginator>
    </div>
</mat-card>
